module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ; __append("<div class=\"wh100 table\">\n    <style>\n        .grid-edit-table {\n            border-spacing  : 2px;\n            border-collapse : separate;\n        }\n\n        .grid-edit-table > div > div {\n            padding    : 10px;\n            background : #eeeeee;\n        }\n\n        .grid-edit-table input[type=text], .grid-edit-table input[type=password], .grid-edit-table input[type=date], .grid-edit-table textarea {\n            width : 100%;\n        }\n    </style>\n    <div>\n        <div class=\"valign-t w100\">\n            <div class=\"wh100 table table-0-100\">\n                <div>\n                    <div name=\"filter\" style=\"background: #f8f8f8;\">\n                        ")
    ;  if (widget.filterTemplate) { 
    ; __append("\n                        ")
    ; __append( UI.Template.render(widget.filterTemplate, { widget: widget }) )
    ; __append("\n                        ")
    ;  } 
    ; __append("\n                    </div>\n                </div>\n                <div>\n                    <div name=\"grid\"></div>\n                </div>\n            </div>\n        </div>\n        <div name=\"data\" class=\"h100\" style=\"vertical-align: top; min-width: ")
    ; __append(escapeFn( widget.editorWidth ))
    ; __append("; background: #f8f8f8; overflow-y: scroll\">\n            <div class=\"cell__abs_container\">\n                <div class=\"cell__abs\">\n                    <div class=\"table table-w-0-100 grid-edit-table\">\n                        ")
    ;  for (var i = 0; i < widget.editor.length; i++) { 
    ; __append("\n                        ")
    ;  var editor = widget.editor[i]; 
    ; __append("\n                        <div>\n                            <div class=\"title\">")
    ; __append(escapeFn( editor.title ))
    ; __append("</div>\n                            <div>\n                                <control ")
    ; __append( Html.attributes(editor) )
    ; __append(" />\n                            </div>\n                        </div>\n                        ")
    ;  } 
    ; __append("\n                    </div>\n                    <button on-click=\"onResetClick\" shortcut=\"Alt+8\">Сбросить</button>\n                    <button on-click=\"onInsertClick\" shortcut=\"Alt+45\">Добавить</button>\n                    <button on-click=\"onUpdateClick\" shortcut=\"Alt+13\">Сохранить</button>\n                    <button on-click=\"onCancelClick\" shortcut=\"Alt+27\">Отмена</button>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n")
  }
  return __output.join("");

}